import { render, staticRenderFns } from "./HelpTooltip.vue?vue&type=template&id=0b464a4e&scoped=true&"
import script from "./HelpTooltip.vue?vue&type=script&lang=js&"
export * from "./HelpTooltip.vue?vue&type=script&lang=js&"
import style0 from "./HelpTooltip.vue?vue&type=style&index=0&id=0b464a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b464a4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b464a4e')) {
      api.createRecord('0b464a4e', component.options)
    } else {
      api.reload('0b464a4e', component.options)
    }
    module.hot.accept("./HelpTooltip.vue?vue&type=template&id=0b464a4e&scoped=true&", function () {
      api.rerender('0b464a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/HelpTooltip.vue"
export default component.exports